(() => {
  const styleId = 'ms-chat-button-fix';
  const css = `
    .squadkin-wrapper-container {
      left: 16px !important;
      transform: scale(1.3) !important;
      transform-origin: left bottom !important;
    }

    @media screen and (max-width: 749px) {
      .squadkin-wrapper-container {
        left: 14px !important;
        transform: scale(1.2) !important;
      }
    }
  `;

  const applyFix = () => {
    const host = document.querySelector('whatsapp-chat-by-squadkin');

    if (!host || !host.shadowRoot) {
      return false;
    }

    let style = host.shadowRoot.getElementById(styleId);

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      host.shadowRoot.appendChild(style);
    }

    style.textContent = css;
    return true;
  };

  if (!applyFix()) {
    const observer = new MutationObserver(() => {
      if (applyFix()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(() => observer.disconnect(), 15000);
  }

  window.addEventListener('load', applyFix, { once: true });
})();
